import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-employee-request.service";


export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-summary-employee-request", currentUserName],
    queryFn: () =>
    HOSummaryEmployeeRequestService.getMySummaryEmployeeRequests( currentUserName ),
    refetchOnMount:"always"
  });

  return response;
};
